function lineIdentifier(line) {
    const value = Number(line && line.id);
    return Number.isFinite(value) ? value : null;
}

function appendByDate(index, value) {
    const date = value && value.work_date;
    if (!date) return;
    const values = index.get(date) || [];
    values.push(value);
    index.set(date, values);
}

function firstByDate(values) {
    const result = new Map();
    (Array.isArray(values) ? values : []).forEach(function (value) {
        const date = value && value.work_date;
        if (date && !result.has(date)) result.set(date, value);
    });
    return result;
}

function buildTimesheetGridIndex(lines) {
    const result = new Map();
    (Array.isArray(lines) ? lines : []).forEach(function (line) {
        const lineId = lineIdentifier(line);
        if (lineId === null) return;
        const externalByDate = new Map();
        const incidentsByDate = new Map();
        const incidentsForDate = new Map();
        const lineIncidents = [];
        (Array.isArray(line.external_entries) ? line.external_entries : [])
            .forEach(function (entry) {
                appendByDate(externalByDate, entry);
            });
        const incidents = Array.isArray(line.incidents) ? line.incidents : [];
        incidents.forEach(function (incident) {
            if (incident && incident.work_date) {
                appendByDate(incidentsByDate, incident);
            } else {
                lineIncidents.push(incident);
            }
        });
        incidentsByDate.forEach(function (datedIncidents, date) {
            const matching = new Set(datedIncidents);
            incidentsForDate.set(date, incidents.filter(function (incident) {
                return !incident.work_date || matching.has(incident);
            }));
        });
        result.set(lineId, {
            entriesByDate: firstByDate(line.entries),
            absenceDaysByDate: firstByDate(line.absence_days),
            externalByDate,
            incidentsByDate,
            incidentsForDate,
            lineIncidents
        });
    });
    return result;
}

module.exports = {
    buildTimesheetGridIndex
};
